import { useEffect } from 'react';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import { LeftVideoTitle, VideoThumbnailSection } from './styled';
import VideoThumnail from './VideoThumbnail';
import { getScreenName } from '../../../Utils/helper';
import { SubtitleVideo } from '../../Product/RatingandReviews/styled';
import { images } from '../../../Constants/ImageUrls';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import { fireEvent } from '../../../Utils/fireEvent';

export default function VideoReviews(props) {
  let { aplus, data, productData, clothDiaper, allReviews } = props;
  let impressionEventData;
  if (data) {
    impressionEventData = {
      category:
        clothDiaper || allReviews
          ? 'impression_section_in_myloshop'
          : 'impression_section_in_pdp',
      id: productData?.id,
      sku_name: productData?.name,
      selling_price: productData?.price,
      pdp_variant: aplus ? 'aplus' : 'aplusplus',
      sku_nickname: productData?.nickname,
      section_name: 'Video Reviews',
    };
  }
  useEffect(() => {
    if (data) {
      fireEvent({
        category:
          clothDiaper || allReviews
            ? 'served_section_in_myloshop'
            : 'served_section_in_pdp',
        id: productData?.id,
        screen_name: getScreenName(),
        sku_name: productData?.name,
        selling_price: productData?.price,
        pdp_variant: aplus ? 'aplus' : 'aplusplus',
        sku_nickname: productData?.nickname,
        section_name: 'Video Reviews',
      });
    }
  }, []);
  return (
    <ScrollWrapper
      sectionId="video_review"
      product_id={productData?.id}
      data={impressionEventData}
      clothDiaper={clothDiaper}
    >
      <VideoThumbnailSection
        className={allReviews ? 'allReviewsDesktop' : ''}
        allReviews={allReviews}
        aplus={aplus}
      >
        {aplus ? (
          <SubtitleVideo allReviews={allReviews} testimonial={true}>
            {' '}
            VIDEO REVIEWS{' '}
          </SubtitleVideo>
        ) : (
          <LeftVideoTitle>Video Reviews</LeftVideoTitle>
        )}
        <AnywhereHorizontalScroll
          allReviews={allReviews}
          firstElementId={`element-0`}
          lastElementId={`element-${data?.length - 1}`}
          leftArrow={<img src={images.arrowdownforward} alt="left_arrow" />}
          rightArrow={<img src={images.arrowdownforward} alt="right_arrow" />}
          scrolledWidth={440}
        >
          {data?.map((element, index) => {
            return (
              <VideoThumnail
                videoData={element}
                itemId={`element-${index}`}
                aplus={aplus}
                key={`element-${index}`}
                productData={productData}
                index={index}
                allReviews={allReviews}
              />
            );
          })}
        </AnywhereHorizontalScroll>
      </VideoThumbnailSection>
    </ScrollWrapper>
  );
}
